import React from 'react'

function StaffContent() {
  return (
    <div>StaffContent</div>
  )
}

export default StaffContent